import { ReactNode } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './ScrollReveal.css';

interface ScrollRevealProps {
  children: ReactNode;
  animation?: 'fade-up' | 'fade-down' | 'fade-left' | 'fade-right' | 'zoom-in' | 'fade-in';
  delay?: number;
  duration?: number;
}

const ScrollReveal = ({
  children,
  animation = 'fade-up',
  delay = 0,
  duration = 0.8
}: ScrollRevealProps) => {
  const { elementRef, isVisible } = useScrollReveal({ threshold: 0.1, triggerOnce: true });

  return (
    <div
      ref={elementRef}
      className={`scroll-reveal ${animation} ${isVisible ? 'revealed' : ''}`}
      style={{
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`
      }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
